import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { ParametrageModule } from '../parametrage/parametrage.module';
import { CanalCommunicationModalDetailComponent } from './modal/canalCommunication-modal-detail/canalCommunication-modal-detail.component';
import { CanalCommunicationModalAjoutComponent } from './modal/canalCommunication-modal-ajout/canalCommunication-modal-ajout.component';
import { ListCanalCommunicationComponent } from './list-canalCommunication/list-canalCommunication.component';
import { FilterCanalCommunicationByNamePipe } from 'src/app/shared/pipes/filter-canalCommunication-by-name/filter-canalCommunication-by-name.pipe';

@NgModule({
	declarations: [
		ListCanalCommunicationComponent,
		CanalCommunicationModalDetailComponent,
		CanalCommunicationModalAjoutComponent
	],
	imports: [SharedModule, ParametrageModule],
	providers: [FilterCanalCommunicationByNamePipe]
})

export class CanalCommunicationModule {}
